import React from "react";
import { filterTriggerStyles } from "./FilterTrigger.styles";
import { ChevronDown } from "@certa/icons/components/ChevronDown";

export type FilterTriggerProps = {
  label: string;
  selectedValues?: string[];
  maxWidth?: string;
} & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick">;

export const FilterTrigger = React.forwardRef<
  HTMLButtonElement,
  FilterTriggerProps
>((props, ref) => {
  const { label, selectedValues = [], maxWidth = "10rem", ...rest } = props;

  const hasSelectedValues = selectedValues.length > 0;
  const firstValue = hasSelectedValues ? selectedValues[0] : "";
  const remainingCount = selectedValues.length - 1;
  const mainText = hasSelectedValues ? `${label}: ${firstValue}` : label;
  const countText = remainingCount > 0 ? ` +${remainingCount}` : "";

  return (
    <button
      ref={ref}
      className={filterTriggerStyles.trigger(maxWidth, hasSelectedValues)}
      type="button"
      {...rest}
    >
      <span className="ellipsis">{mainText}</span>
      {countText && (
        <span className={filterTriggerStyles.countText}>{countText}</span>
      )}
      <ChevronDown size={12} className={filterTriggerStyles.caret} />
    </button>
  );
});
